import { UserRow } from '@modules/users/store/types';
import {
  getUserRowRoleFromUserTypeAndState,
  isValidUserTypeAndState,
} from '@modules/users/utils';
import { ListUserViewFragment } from 'generated/graphql';

export const getUsersStateFromListUsersResponse = (
  usersData: ListUserViewFragment[] | undefined,
): UserRow[] => {
  if (!usersData) {
    return [];
  }

  return usersData.reduce((users: UserRow[], userData) => {
    if (
      !userData.state ||
      !isValidUserTypeAndState(userData.type, userData.state)
    ) {
      return users;
    }

    const user: UserRow = {
      id: userData.id,
      name: `${userData.firstName} ${userData.lastName}`,
      email: userData.email,
      role: getUserRowRoleFromUserTypeAndState(userData.type, userData.state),
      state: userData.state,
      type: userData.type,
    };

    return [...users, user];
  }, []);
};
